import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';

const Contact = () => {
    const [alert, setAlert] = useState(false);
    const sendEmail = e => {
        e.preventDefault();
        emailjs.sendForm('service_gnok9o9', 'template_coswmtm', e.target, 'user_DlENTFRrgTMvIic04krDB')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        setAlert(true);
        e.target.reset();
    }
    return (
        <div className='container contact-form section'>
            <div className='row'>
                <div className='col-lg-6'>
                    <h2 className='title form-title'>Let's Talk</h2>
                    <h2 className='mbl-form-title'>Let's Talk</h2>
                    <h1 className='title-bg form-header'>CONTACT</h1>
                </div>
                <div className='col-lg-6'>
                    <form onSubmit={sendEmail}>
                        <div className='d-flex'>
                            <div className='input-field'>
                                <label style={{ fontWeight: '600' }} htmlFor="">Name</label>
                                <br />
                                <input style={{ width: '200px', lineHeight: '35px', margin: '18px' }} type="text" name='name' placeholder=' Enter your name' required />
                            </div>
                            <div className='input-field email-field'>
                                <label style={{ fontWeight: '600' }} htmlFor="">Email<span className='address'>Address</span> </label>
                                <br />
                                <input style={{ width: '220px', lineHeight: '35px', margin: '18px' }} type="text" name='email' placeholder=' Enter your email' required />
                            </div>
                        </div>
                        <br />
                        <label className='msg-label' style={{ fontWeight: '600' }} htmlFor="">Message</label>
                        <br />
                        <textarea style={{ width: '455px', paddingBottom: '80px', margin: '18px' }} type="text" name='message' placeholder=' Enter your messsage' required />
                        <br />
                        <button className='m-3 form-btn' type='submit'>Submit</button>
                    </form>
                    {
                        alert && <div class="alert alert-success" role="alert">
                            Thanks for messaging. Will Catch You Soon! 😀
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default Contact;